import { generatePath } from 'react-router';
import { DRIVE_PAGE } from '@/common/constants/pages';
import URLProvider from '@/common/services/URLProvider';
import { DriveItemType } from '@/drive/entities/DriveItem';
import { DriveSection } from './driveSection';
export function fromDriveNode(item) {
    if (item.type === DriveItemType.Folder) {
        return {
            id: item.id,
            title: item.title,
            type: item.type,
            collapsed: true,
            children: item.children?.map(fromDriveNode),
        };
    }
    else {
        return {
            id: item.id,
            title: item.title,
            type: item.type,
            collectionId: item.collectionId,
        };
    }
}
export function getDriveTreeItemUrl(item) {
    if (item.type === 'appSection') {
        return item.url;
    }
    else if (item.type === 'collection') {
        return URLProvider.collectionDetailPage({ id: item.collectionId });
    }
    else {
        return generatePath(DRIVE_PAGE, { section: DriveSection.DriveRoot, selectedId: item.id });
    }
}
